import profilePicOne from "./1.jpg";
import profilePicTwo from "./2.jpg";
import profilePicThree from "./3.jpg";
import profilePicFour from "./4.jpg";
import profilePicFive from "./5.jpg";
import profilePicSix from "./6.jpg";

export const profilePics = [
  profilePicOne,
  profilePicTwo,
  profilePicThree,
  profilePicFour,
  profilePicFive,
  profilePicSix,
];
